import api from './api';

export interface EvalTest {
  key: string;
  name: string;
  type: string;               // present|type_valid|regex|range|grounded|equals_golden|cross_field|llm_judge
  field_key?: string | null;
  params: Record<string, any>;
  required: boolean;
}

export interface TestResult {
  key: string; name: string; type: string; field_key?: string | null;
  required: boolean; passed: boolean | null; detail?: string | null;
}

export interface SuiteResults {
  results: TestResult[]; required_failures: number; total: number; passed: number;
}

export const TEST_TYPES = [
  'present', 'type_valid', 'regex', 'range', 'grounded', 'equals_golden', 'cross_field', 'llm_judge',
];

class EvalsService {
  async getSuite(): Promise<{ suite: any; current_version: { tests: EvalTest[] } | null }> {
    return (await api.get('/evals/suite')).data;
  }
  async setSuite(tests: EvalTest[]): Promise<any> {
    return (await api.put('/evals/suite', { tests })).data;
  }
  async suggest(documentId: string, wholeDocument = false): Promise<{ tests: EvalTest[] }> {
    return (await api.post('/evals/suggest', { document_id: documentId, whole_document: wholeDocument })).data;
  }
  async runResults(runId: string): Promise<SuiteResults> {
    return (await api.get(`/evals/runs/${runId}/results`)).data;
  }
}

export const evalsService = new EvalsService();
export default evalsService;
